import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  height: 78px;

  label {
    display: block;
    color: #000;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 16px;
  }

  input {
    display: none;
  }

  .logo_container {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 120px;
      height: 120px;
      object-fit: contain;
    }
  }

  div > p {
    color: #f00;
    margin: 0;
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Button = styled.button`
  background-color: ${({ active }) =>
    active ? "var(--color-primary)" : "#E8E8E8"};
  color: ${({ active }) => (active ? "#fff" : "#96989A")};
  cursor: ${({ active }) => (active ? "pointer" : "not-allowed")};

  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  gap: 8px;
  padding: 6px 10px;
  width: 192px;

  .load {
    border: 2px solid #fff;
    border-radius: 50%;
    border-top: 2px solid #a0a0a0;
    width: 20px;
    height: 20px;
    animation: ${spin} 1s linear infinite;
  }

  &:hover {
    background: var(--color-primary-dark);
  }
`;
